<template>
  <div>
    <VTable class="managers-manager" :items="computedItems" :fields="fields" :checked-rows="checkedItems"
      :loading="loading" :on-toggle-row="onToggleRow" :on-input-search="onInputSearch" :on-edit-item="onEditItem"
      :on-delete-item="onDeleteItem"     :on-show-comments="onShowComments"
      :on-click-to-add="onClickToAdd" searchPlaceholder="Search for blog title...." hover
      striped border small fixed dark>
      <template #footer>
        <VPagination :items-count="itemsCount" class="user-manager-card__footer-pagination" />
      </template>
    </VTable>
  </div>
</template>
<script>
import {
  createBlogMixin,
  blogsStore,
} from "@/mixins/blogsMixin";
import { debounce } from "@/utils/debounce";
import ModalType from '../utils/dictionaries/modalType';
import URLS from "@/constants/url";
import { auctionManagerStore, createAuctionManagerMixin } from '@/mixins/auctionsManagerMixin'

export default {
  name: 'Blogs',
  mixins: [createBlogMixin(), createAuctionManagerMixin()],
  data() {
    return {
      title: '',
      content: '',
      isDisabled: false,
      loading: false,

      data: [],
      count: 0,
      checkedItems: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "rowId", label: "" },
       
        { key: "truncated_title", label: "Title", _style: "max-width: 100px" },
        {
          key: "truncated_content",
          label: "Content",
          // _style: "min-width: 125px",
          // _classes: "blog-content"
        },
        { key: "comments", label: "Comments", },
        { key: "category", label: "Category", _style: "max-width: 100px" }, 
        { key: "link", label: "Link", _style: "max-width: 50px" }, 
        { key: "action", _style: "max-width: 20px;min-width:20px" },
      ]
    },
    items() {
      return this[blogsStore.getterTypes.GETTER_BLOGS];
    },
    itemsCount() {
      return this[blogsStore.getterTypes.GETTER_BLOGS_COUNT];
    },
    computedItems() {
      return this.items && this.items.map(item => {
        return {
          ...item,
          truncated_title: item.title.length > 100 ? item.title.substring(0, 100) + '...' : item.title,
          truncated_content: item.content.length > 100 ? item.content.substring(0, 100) + '...' : item.content,
          link: this.toLink(item)
        }
      })
    },
    isReload() {
      return this[blogsStore.getterTypes.GETTER_PAGE_RELOAD];
    },

  },

  watch: {
    $route() {
      this.loadData()
    },
    isReload(newValue){
      this.loadData();
    },
  },

  async created() {
    this[auctionManagerStore.actionTypes.ACTION_JOIN_TO_CAR_MANAGER]()

    await this.loadData()

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        }

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => { })
      },
      200
    )
  },
  methods: {
    toLink(blog){
      console.log("blog",blog)
      return `${URLS.app}/tips-&-tricks/${blog.page_url}/${blog.uuid}`
    },
    onShowComments(item) {
      const { comments, ...itemWithoutComments } = item;
      itemWithoutComments['type'] = 'blog'
      return this.$modals.open(ModalType.CommentsModal, {
          ...itemWithoutComments,
          disabled: false
        });
    },
    onToggleRow(item) {
      // this.checkedItems = [item]
    },
    onInputSearch(t) {
      this.searchFn(t)
      console.log('onInputSearch', t)
    },
    onEditItem(item) {
      this.$modals.open(ModalType.BlogModal, item)
    },
    async onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          const blogId = item.id
          this.$modals.close(ModalType.ConfirmationModal)
          await this[blogsStore.actionTypes.ACTION_DELETE_BLOG]({ blogId })
        } catch (error) {
          console.log(error)
          console.log(error.response)
        }
      }
      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: `Are you sure you want to delete <strong>${item.title}</strong> blog?`,
        buttonText: 'Delete',
        onClickButton: deleteAction
      })
    },
    onClickToAdd() {
      this.$modals.open(ModalType.BlogModal, {})
    },
    async loadData() {
      this.loading = true;
      await this[blogsStore.actionTypes.ACTION_LOAD_BLOGS]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      await this[blogsStore.mutationTypes.MUTATION_SET_PAGE_RELOAD](false)
      this.loading = false
    },
  }
}
</script>
